module.exports = __webpack_public_path__ + "img/arrow_up_2.55705ea8.svg";